import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Slide {
  eyebrow: string;
  title: string;
  desc: string;
  cta: string;
  to: string;
  image: string;
}

const slides: Slide[] = [
  {
    eyebrow: "最新更新剧情",
    title: "第十二集：甜蜜的结局",
    desc: "春雨再一次落下的那天，甜品店重新开门，柜台后站着两个人——全剧温柔收尾。",
    cta: "查看本集剧情",
    to: "/episode/ep-12",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20dessert%20shop%20reopening%20at%20dusk%20with%20rain%20on%20the%20window%20and%20a%20cozy%20glowing%20interior%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20dreamy%20cinematic%20wide%20shot%2C%20clean%20minimal%20composition&width=1600&height=900&seq=sp-hero-ep&orientation=landscape",
  },
  {
    eyebrow: "特别推荐角色",
    title: "顾时衍 · 把温柔藏进沉默里的人",
    desc: "从假装不认识，到当众沉默，再到把选择权交还给她——他用了整整十二集学会开口。",
    cta: "查看角色档案",
    to: "/character/gu-shiyan",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20rainy%20city%20street%20at%20night%20with%20a%20lone%20figure%20holding%20a%20black%20umbrella%20under%20warm%20neon%20reflections%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20anime%20illustration%2C%20moody%20cinematic%20wide%20shot%2C%20clean%20composition&width=1600&height=900&seq=sp-hero-ch&orientation=landscape",
  },
  {
    eyebrow: "观看指南热点",
    title: "结局解析：甜蜜与惩罚究竟指什么？",
    desc: "从招牌、书签与雨夜三个意象出发，拆解《甜蜜惩罚》结局真正的含义。",
    cta: "阅读观看指南",
    to: "/guide",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20a%20stack%20of%20books%20and%20a%20cup%20of%20tea%20by%20a%20rainy%20window%2C%20warm%20orange%20and%20cream%20palette%2C%20soft%20stylized%20anime%20illustration%2C%20warm%20lamp%20light%2C%20clean%20minimal%20composition&width=1600&height=900&seq=sp-hero-guide&orientation=landscape",
  },
];

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => window.clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full h-[300px] md:h-[420px] rounded-lg overflow-hidden bg-foreground-900">
      {slides.map((slide, index) => (
        <div
          key={slide.title}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === active ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`甜蜜惩罚 ${slide.eyebrow}`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20"></div>
          <div className="relative h-full w-full flex flex-col justify-center px-6 md:px-12 max-w-2xl">
            <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label mb-3">
              <i className="ri-fire-line"></i>
              {slide.eyebrow}
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-background-50 leading-snug mb-3">{slide.title}</h2>
            <p className="text-sm md:text-base text-background-200 leading-relaxed mb-5 max-w-lg font-label">
              {slide.desc}
            </p>
            <Link
              to={slide.to}
              className="inline-flex w-fit items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {slide.cta}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      ))}

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="absolute left-3 md:left-4 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/80 text-foreground-800 hover:bg-background-50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="absolute right-3 md:right-4 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/80 text-foreground-800 hover:bg-background-50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-4 left-6 md:left-12 flex items-center gap-2">
        {slides.map((slide, index) => (
          <button
            key={slide.title}
            type="button"
            aria-label={`切换到第${index + 1}张`}
            onClick={() => setActive(index)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === active ? "w-8 bg-accent-500" : "w-3 bg-background-50/60"
            }`}
          />
        ))}
      </div>
    </div>
  );
}